import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { BASE_URL, AUTH } from '../../config/axios';
import { AddwithWhiteCircle, UpdatePencil } from '../AllSvg';
import Select from 'react-select';




const AddConsultant = ({ getSubConsultant }) => {
    const [errors, setErrors] = useState({});
    const [show, setShow] = useState(false);

    const [formData, setFormData] = useState({
        name: '',

    });

    const handleShow = () => setShow(true);
    const handleClose = () => {
        setShow(false);
        setFormData({
            name: '',

        })
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const validateform = () => {
        const newErrors = {};
        const requiredFields = ["name",];

        requiredFields.forEach((field) => {
            const value = formData[field];

            // For string fields
            if (typeof value === "string" && value.trim() === "") {
                newErrors[field] = "This field is required!";
            }

        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateform()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            try {

                const res = await axios.post(`${BASE_URL}/dpr/subconsultant/`, formData);

                if (res.status === 201 || res.status === 200) {
                    toast.success("Data  added successfully!");
                    handleClose();
                    await getSubConsultant();
                }
            } catch (err) {
                console.error("Error adding Data :", err);
                if (err.response?.data) {
                    toast.error(`Failed to add Data : ${JSON.stringify(err.response.data)}`);
                } else {
                    toast.error("Failed to add Data ");
                }
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };


    return (
        <>
            <button
                title="Add Sector"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Sector
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title>Add Sector</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form className="add-activity" onSubmit={handleFormSubmit}>
                        <div className="parent-div">
                            <div className="bdy-div">



                                <div title="Sector Name" className="flex-column">
                                    <label
                                        htmlFor="name"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Sector Name<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        placeholder="Sector Name"
                                        onChange={handleInputChange}
                                        value={formData.name}
                                        className={`form-input  ${errors.name ? "input-error" : ""}`}

                                    />
                                    {errors.name && (
                                        <span className="error-message font-size-text">
                                            {errors.name}
                                        </span>
                                    )}
                                </div>

                            </div>

                            <div className='flex-row justify-center'>
                                <div style={{ marginRight: "20px" }}>
                                    <button className="cancelbutton" onClick={handleClose}>Cancel</button>
                                </div>
                                <div>
                                    <button class="submitaddbutton" onClick={handleFormSubmit} type='submit'>
                                        <span class="text">Submit</span>
                                        <span class="icon">
                                            <svg
                                                viewBox="0 0 24 24"
                                                height="24"
                                                width="24"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M9.707 19.121a.997.997 0 0 1-1.414 0l-5.646-5.647a1.5 1.5 0 0 1 0-2.121l.707-.707a1.5 1.5 0 0 1 2.121 0L9 14.171l9.525-9.525a1.5 1.5 0 0 1 2.121 0l.707.707a1.5 1.5 0 0 1 0 2.121z">
                                                </path>
                                            </svg>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};

const UpdateConsultant = ({ i, getSubConsultant }) => {
    const [errors, setErrors] = useState({});
    const [show, setShow] = useState(false);
    const [subCompany, setSubCompany] = useState([]);

    const [formData, setFormData] = useState({
        name: '',

    });

    const handleShow = () => {
        setShow(true);
        setFormData(i);
    }
    const handleClose = () => {
        setShow(false);
        setFormData({
            name: '',

        })
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const validateform = () => {
        const newErrors = {};
        const requiredFields = ["name", "division", "workstats"];

        requiredFields.forEach((field) => {
            const value = formData[field];

            // For string fields
            if (typeof value === "string" && value.trim() === "") {
                newErrors[field] = "This field is required!";
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateform()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            try {

                const res = await axios.put(`${BASE_URL}/dpr/subconsultant/${i.id}/`, formData, AUTH());

                if (res.status === 201 || res.status === 200) {
                    toast.success("Data updated successfully!");
                    setShow(false);
                    setFormData({
                        name: '',
                        division: ''
                    });
                    getSubConsultant();
                }
            } catch (err) {
                console.error("Error Updating Data:", err);
                if (err.response?.data) {
                    toast.error(`Failed to update Data: ${JSON.stringify(err.response.data)}`);
                } else {
                    toast.error("Failed to update Data");
                }
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };


    return (
        <>
            <button
                title="Update Sector"
                className="model-edit-button"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title>Update Sub-Consultant Details</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form className="add-activity" onSubmit={handleFormSubmit}>
                        <div className="parent-div">
                            <div className="bdy-div">



                                <div title="Sectpr Name" className="flex-column">
                                    <label
                                        htmlFor="name"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Sector Name<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        placeholder="Sector Name"
                                        onChange={handleInputChange}
                                        value={formData.name}
                                        className={`form-input  ${errors.name ? "input-error" : ""}`}

                                    />
                                    {errors.name && (
                                        <span className="error-message font-size-text">
                                            {errors.name}
                                        </span>
                                    )}
                                </div>


                            </div>

                            <div className='flex-row justify-center'>
                                <div style={{ marginRight: "20px" }}>
                                    <button className="cancelbutton" onClick={handleClose}>Cancel</button>
                                </div>
                                <div>
                                    <button class="submitaddbutton" onClick={handleFormSubmit} type='submit'>
                                        <span class="text">Update</span>
                                        <span class="icon">
                                            <svg
                                                viewBox="0 0 24 24"
                                                height="24"
                                                width="24"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M9.707 19.121a.997.997 0 0 1-1.414 0l-5.646-5.647a1.5 1.5 0 0 1 0-2.121l.707-.707a1.5 1.5 0 0 1 2.121 0L9 14.171l9.525-9.525a1.5 1.5 0 0 1 2.121 0l.707.707a1.5 1.5 0 0 1 0 2.121z">
                                                </path>
                                            </svg>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteConslutant = ({ i, getSubConsultant }) => {
    const [show, setShow] = useState(false);

    const handleShow = () => {
        setShow(true)
    }

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.delete(
                `${BASE_URL}/dpr/subconsultant/${i.id}/`
            );

            if (res.status === 200) {
                toast.success(`Data deleted successfully`);
                await getSubConsultant(); // refresh table
                setShow(false);
            }
        } catch (err) {
            toast.error("Failed to delete data");
            console.error(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete "
                className="model-delete-button"
                onClick={handleShow}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal
                show={show}
                onHide={() => setShow(false)}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Delete Sector: {i.name}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Are you sure you want to delete{" "}
                        <strong>{i.name}</strong>?
                    </p>
                    <div className="button-models">
                        <button
                            className="model-button model-button-cancel"
                            onClick={() => setShow(false)}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};


export { AddConsultant, UpdateConsultant, DeleteConslutant }